import * as R from "ramda";

import qs from "query-string";

// [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10] => [[0, 1, 2], [3, 4], [5, 6, 7], [8, 9], [10]]
export const chunkAlternate = (firstGroupSize, secondGroupSize, array) => {
  let currGroupSize = firstGroupSize;
  let currKey = 0;

  return array.reduce((acc, curr) => {
    if (currKey % currGroupSize === 0) {
      acc.push([curr]);
    } else {
      acc[acc.length - 1].push(curr);
    }

    currKey++;

    if (
      currGroupSize === firstGroupSize &&
      acc[acc.length - 1].length === firstGroupSize
    ) {
      currGroupSize = secondGroupSize;
      currKey = 0;
    } else if (
      currGroupSize === secondGroupSize &&
      acc[acc.length - 1].length === secondGroupSize
    ) {
      currGroupSize = firstGroupSize;
      currKey = 0;
    }

    return acc;
  }, []);
};

export const updateResponse = (
  facetString,
  facetStringRef,
  response,
  prevState,
) => {
  return R.mergeDeepWithKey(
    (k, l, r) => {
      //determine if the facets have changed
      return k === "results" && facetString === facetStringRef.current
        ? R.concat(l, r)
        : r;
    },
    prevState,
    response,
  );
};

export const updateFacets = (facetId, valueId, prevState) => {
  return R.cond([
    [
      (state) => state.hasOwnProperty(facetId),
      R.compose(
        R.when(
          R.propSatisfies((array) => array.length === 0, facetId),
          R.compose(R.assoc("page", 1), R.dissoc(facetId)),
        ),
        R.evolve({
          [facetId]: R.symmetricDifference([valueId]),
          ["page"]: () => 1,
        }),
      ),
    ],
    [
      (state) => state.hasOwnProperty(facetId) === false,
      R.compose(R.assoc("page", 1), R.assoc(facetId, [valueId])),
    ],
  ])(prevState);
};

export const omitFacets = (facetId, prevState) => {
  return R.omit(facetId, prevState);
};

export const createFacetString = (activeFacets) => {
  return R.compose(
    R.reduce(R.concat, ""),
    R.values,
    R.mapObjIndexed((value, key, obj) => {
      return key !== "page"
        ? `&${key}=${value.map((val, i, arr) =>
            arr.length - 1 === i
              ? encodeURIComponent(`${val}`)
              : encodeURIComponent(`${val};`),
          )}`
        : "";
    }),
  )(activeFacets).replace(/,/g, "");
};

export const createPageString = (activeFacets) => {
  return R.compose(
    R.reduce(R.concat, ""),
    R.values,
    R.mapObjIndexed((value, key, obj) =>
      key === "page" ? `&${key}=${value}` : "",
    ),
  )(activeFacets);
};

export const initFacetsFromQs = (facetKeys) => {
  return R.compose(
    R.map((item) => (Array.isArray(item) ? item : [item])),
    R.pick(facetKeys),
  )(
    qs.parse(window.location.search, {
      arrayFormat: "separator",
      arrayFormatSeparator: ";",
    }),
  );
};

export const updateQueryParams = (
  facetKeys,
  activeFacets,
  includeSearchTerm,
  searchTerm,
  includeSort,
) => {
  const isEE =
    document.body.classList.contains("is-preview") ||
    document.body.classList.contains("is-page-editor");
  const isStorybook = process.env.STORYBOOK;

  if (includeSort) {
    facetKeys = facetKeys.concat(["sortBy"]);
  }

  const facets = R.pick(facetKeys, activeFacets);

  const facetParams = qs.stringify(facets, {
    arrayFormat: "separator",
    arrayFormatSeparator: ";",
  });
  let otherParams = qs.exclude(window.location.search, facetKeys);

  if (!isEE && !isStorybook && includeSearchTerm && searchTerm !== "") {
    otherParams = "";
  }

  window.history.pushState(
    {},
    "",
    `${window.location.origin}${window.location.pathname}${otherParams}${
      otherParams === "" && facetParams !== ""
        ? `?${facetParams}`
        : facetParams === ""
        ? ""
        : `&${facetParams}`
    }${
      !isStorybook &&
      includeSearchTerm &&
      searchTerm !== "" &&
      facetParams !== ""
        ? `&q=${searchTerm}`
        : !isStorybook &&
          includeSearchTerm &&
          searchTerm !== "" &&
          facetParams === ""
        ? `?q=${searchTerm}`
        : ""
    }`,
  );
};
